export default __webpack_public_path__ + "static/media/satellite-streets-v11-small.8a3ce7b1.png";